document.addEventListener('DOMContentLoaded', function () {
    const scheduleIdle = window.requestIdleCallback || function (cb) {
    setTimeout(cb, 250);
  };

let swiperAssetsPromise = null;

function loadSwiperAssets() {
  if (window.Swiper) return Promise.resolve();

  if (swiperAssetsPromise) return swiperAssetsPromise;

  swiperAssetsPromise = new Promise((resolve, reject) => {
    const existingCss = document.querySelector('link[data-swiper-css]');
    const existingJs = document.querySelector('script[data-swiper-js]');

    const finish = () => {
      if (window.Swiper) resolve();
      else reject(new Error('Swiper failed to load'));
    };

    if (!existingCss) {
      const css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
      css.setAttribute('data-swiper-css', 'true');
      document.head.appendChild(css);
    }

    if (existingJs) {
      if (window.Swiper) {
        resolve();
      } else {
        existingJs.addEventListener('load', finish, { once: true });
        existingJs.addEventListener('error', reject, { once: true });
      }
      return;
    }

    const js = document.createElement('script');
    js.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    js.defer = true;
    js.setAttribute('data-swiper-js', 'true');
    js.addEventListener('load', finish, { once: true });
    js.addEventListener('error', reject, { once: true });
    document.head.appendChild(js);
  });

  return swiperAssetsPromise;
}

  function initializeSwiper(section) {
    const slidesMobile = parseFloat(section.getAttribute('data-slides-mobile')) || 2;
    const slidesDesktop = parseFloat(section.getAttribute('data-slides-desktop')) || 4;
    const spaceBetweenMobile = parseFloat(section.getAttribute('data-space-between-mobile')) || 2;
    const spaceBetweenDesktop = parseFloat(section.getAttribute('data-space-between-desktop')) || 2;
    const autoplay = section.getAttribute('data-auto-scroll') === 'true';

    const nextBtn = section.querySelector('.swiper-button-next');
    const prevBtn = section.querySelector('.swiper-button-prev');

    const swiperInstance = new Swiper(section, {
      slidesPerView: slidesDesktop,
      spaceBetween: spaceBetweenDesktop,
      mousewheel: { forceToAxis: true, sensitivity: 1 },
      autoplay: autoplay ? { delay: 50 } : false,
      speed: autoplay ? 4650 : 1000,
      loop: !!autoplay,
      breakpoints: {
        320: { slidesPerView: slidesMobile, spaceBetween: spaceBetweenMobile },
        1040: { slidesPerView: slidesDesktop, spaceBetween: spaceBetweenDesktop },
      },
      navigation: { nextEl: nextBtn, prevEl: prevBtn },
      pagination: {
        el: section.querySelector('.swiper-pagination'),
        type: 'progressbar',
      },
    });

    if (autoplay) {
      let paused = false;
      let currentTranslate = 0;

      section.addEventListener('mouseenter', () => {
        if (paused) return;
        paused = true;
        const matrix = window.getComputedStyle(swiperInstance.wrapperEl).transform;
        currentTranslate = matrix !== 'none' ? parseFloat(matrix.split(',')[4]) : 0;
        swiperInstance.autoplay.stop();
        swiperInstance.wrapperEl.style.transition = 'none';
        swiperInstance.setTranslate(currentTranslate);
      });

      section.addEventListener('mouseleave', () => {
        if (!paused) return;
        paused = false;
        setTimeout(() => { swiperInstance.autoplay.start(); }, 150);
      });
    }

    return swiperInstance;
  }

  function initializeSwipers() {
    const sections = document.querySelectorAll('.swiper-container:not([data-swiper-initialized])');
    if (!sections.length) return;

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const section = entry.target;
            obs.unobserve(section);
            if (!section.swiper) {
              setTimeout(() => {
                initializeSwiper(section);
                section.setAttribute('data-swiper-initialized', 'true');
                section.style.opacity = 1;
              }, 0);
            }
          }
        });
      }, { rootMargin: '200px' });

      sections.forEach(section => {
        observer.observe(section);
      });
    } else {
      const schedule = window.requestIdleCallback || (cb => setTimeout(cb, 200));
      schedule(() => {
        sections.forEach(section => {
          if (section.swiper) section.swiper.destroy();
          initializeSwiper(section);
          section.setAttribute('data-swiper-initialized', 'true');
          section.style.opacity = 1;
        });
      });
    }
  }

function lightGalleryInit() {
  const expandImageButtons = document.querySelectorAll('.expand-image-btn');
  if (!expandImageButtons.length) return;

  let lightbox = document.getElementById('lightbox');

  if (!lightbox) {
    lightbox = document.createElement('div');
    lightbox.id = 'lightbox';
    lightbox.innerHTML =
      '<div class="lightbox-content">' +
        '<button class="lightbox-nav lightbox-prev" type="button" aria-label="Previous image">&#8592;</button>' +
        '<div class="loader"></div>' +
        '<img src="" alt="Expanded Image" style="display:none"/>' +
        '<button class="lightbox-nav lightbox-next" type="button" aria-label="Next image">&#8594;</button>' +
        '<button id="close-lightbox" type="button" style="display:none">&times;</button>' +
      '</div>';
    document.body.appendChild(lightbox);
  }

  const lightboxImg = lightbox.querySelector('img');
  const closeButton = lightbox.querySelector('#close-lightbox');
  const loader = lightbox.querySelector('.loader');
  const prevButton = lightbox.querySelector('.lightbox-prev');
  const nextButton = lightbox.querySelector('.lightbox-next');

  let currentGallery = [];
  let currentIndex = 0;

  function showImage(index) {
    if (!currentGallery.length) return;

    currentIndex = index;

    const imgSrc = currentGallery[currentIndex].getAttribute('data-img-src');
    const imgAlt = currentGallery[currentIndex].getAttribute('alt') || 'Expanded Image';

    if (!imgSrc) return;

    loader.style.display = 'block';
    lightboxImg.style.display = 'none';
    closeButton.style.display = 'none';

    prevButton.style.display = currentGallery.length > 1 ? 'flex' : 'none';
    nextButton.style.display = currentGallery.length > 1 ? 'flex' : 'none';

    lightboxImg.src = imgSrc;
    lightboxImg.alt = imgAlt;
    lightbox.style.display = 'flex';
  }

  function closeLightbox() {
    lightbox.style.display = 'none';
    lightboxImg.src = '';
    currentGallery = [];
    currentIndex = 0;
  }

  function showNext() {
    if (currentGallery.length <= 1) return;
    const nextIndex = (currentIndex + 1) % currentGallery.length;
    showImage(nextIndex);
  }

  function showPrev() {
    if (currentGallery.length <= 1) return;
    const prevIndex = (currentIndex - 1 + currentGallery.length) % currentGallery.length;
    showImage(prevIndex);
  }

  expandImageButtons.forEach(button => {
    button.addEventListener('click', () => {
      const popup = button.closest('.customer-gallery-popup');
      if (!popup) return;

      currentGallery = Array.from(popup.querySelectorAll('.expand-image-btn'));
      currentIndex = currentGallery.indexOf(button);

      if (currentIndex === -1) return;

      showImage(currentIndex);
    });
  });

  lightboxImg.addEventListener('load', () => {
    loader.style.display = 'none';
    lightboxImg.style.display = 'block';
    closeButton.style.display = 'flex';
  });

  closeButton.addEventListener('click', closeLightbox);
  prevButton.addEventListener('click', e => {
    e.stopPropagation();
    showPrev();
  });
  nextButton.addEventListener('click', e => {
    e.stopPropagation();
    showNext();
  });

  lightbox.addEventListener('click', e => {
    if (e.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', e => {
    if (lightbox.style.display !== 'flex') return;

    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') showPrev();
    if (e.key === 'ArrowRight') showNext();
  });
}

  function initializeVideoControls() {
    document.querySelectorAll('.banner__media--video').forEach(container => {
      const video = container.querySelector('video');
      const muteToggle = container.querySelector('.mute-toggle');
      const playPauseToggle = container.querySelector('.play-pause-toggle');
      if (!video || !muteToggle || !playPauseToggle) return;

      playPauseToggle.setAttribute('data-state', video.paused ? 'paused' : 'playing');
      muteToggle.setAttribute('data-state', video.muted ? 'muted' : 'unmuted');

      muteToggle.addEventListener('click', () => {
        video.muted = !video.muted;
        muteToggle.setAttribute('data-state', video.muted ? 'muted' : 'unmuted');
      });

      playPauseToggle.addEventListener('click', () => {
        if (video.paused) { video.play(); playPauseToggle.setAttribute('data-state', 'playing'); }
        else { video.pause(); playPauseToggle.setAttribute('data-state', 'paused'); }
      });

      video.addEventListener('play', () => playPauseToggle.setAttribute('data-state', 'playing'));
      video.addEventListener('pause', () => playPauseToggle.setAttribute('data-state', 'paused'));
    });
  }

  function sortOverlapSections() {
    const overlaySections = document.querySelectorAll('.banner--overlap');
    if (!overlaySections.length) return;

    requestAnimationFrame(() => {
      const isMobile = window.innerWidth < 768;
      const measurements = Array.from(overlaySections).map(section => {
        const overlayContent = section.querySelector('.banner__box');
        if (!overlayContent) return null;
        return {
          section,
          height: overlayContent.offsetHeight,
          padding: isMobile ? 20 : (parseInt(section.getAttribute('data-padding-bottom'), 10) || 0),
        };
      });

      requestAnimationFrame(() => {
        measurements.forEach(m => {
          if (!m) return;
          m.section.style.marginBottom = `${(m.height - 65) + m.padding}px`;
        });
      });
    });
  }

    function searchModal() {
    const searchInput = document.querySelector('#Search-In-Modal');
    if (!searchInput) return;
    const modal = document.querySelector('.search-modal');
    if (!modal) return;
    if (searchInput.dataset.bound === 'true') return;

    searchInput.addEventListener('focus', () => modal.classList.add('focused'));
    searchInput.addEventListener('blur', () => modal.classList.remove('focused'));
    searchInput.dataset.bound = 'true';
  }

  function popup() {
    const popups = document.querySelectorAll('.popup');
    const popupBtns = document.querySelectorAll('.popup-btn');
    const body = document.body;
    if (!popups.length) return;

    popupBtns.forEach(btn => {
      btn.addEventListener('click', function (event) {
        event.stopPropagation();
        const btnId = btn.getAttribute('id');
        const needsContent = btn.getAttribute('data-page');

        popups.forEach(p => {
          if (p.getAttribute('id') === btnId) {
            p.classList.add('active');
            body.classList.add('popup-open');
            const inner = p.querySelector('.popup__inner');
            if (inner) setTimeout(() => { inner.scrollTop = 0; }, 50);
            if (needsContent) buildContent(needsContent);
            p.querySelectorAll('img[data-src]').forEach(img => {
              if (!img.src || img.src === window.location.href) {
                img.src = img.getAttribute('data-src');
              }
            });
            setTimeout(() => {
              p.querySelectorAll('.swiper-container').forEach(section => {
                if (!section.swiper) {
                  initializeSwiper(section);
                  section.setAttribute('data-swiper-initialized', 'true');
                  section.style.opacity = 1;
                }
              });
            }, 50);
          }
        });
      });
    });

    document.addEventListener('click', function (event) {
      popups.forEach(p => {
        const inner = p.querySelector('.popup__inner');
        const lightbox = document.querySelector('#lightbox');
        if (
          p.classList.contains('active') &&
          inner &&
          !inner.contains(event.target) &&
          !(lightbox && (lightbox === event.target || lightbox.contains(event.target)))
        ) {
          p.classList.remove('active');
          body.classList.remove('popup-open');
        }
      });
    });

    popups.forEach(p => {
      const inner = p.querySelector('.popup__inner');
      if (!inner) return;
      inner.addEventListener('click', e => e.stopPropagation());
      const closeBtn = inner.querySelector('.popup__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          p.classList.remove('active');
          body.classList.remove('popup-open');
        });
      }
    });

    function buildContent(data) {
      fetch(`/pages/${data}`)
        .then(r => r.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const mainContent = doc.querySelector('main');
          if (!mainContent) return;
          document.querySelector('.popup.active .popup__content').innerHTML = mainContent.innerHTML;

          setTimeout(() => {
            document.querySelectorAll('.popup.active .swiper-container').forEach(section => {
              if (section.swiper) section.swiper.destroy();
              initializeSwiper(section);
              section.setAttribute('data-swiper-initialized', 'true');
              section.style.opacity = 1;
            });
            lightGalleryInit();
            formatGalleryTable();
          }, 100);
        });
    }
  }

  function formatGalleryTable() {
    document.querySelectorAll('.customer-gallery-popup__table .metafield-rich_text_field').forEach(container => {
      const paragraphs = Array.from(container.querySelectorAll('p'));
      const wrapper = document.createElement('div');
      wrapper.classList.add('metafield-wrapper');

      let currentItem = null;

      paragraphs.forEach(p => {
        if (p.textContent.trim() === '') {
          currentItem = null;
        } else {
          if (!currentItem) {
            currentItem = document.createElement('div');
            currentItem.classList.add('item');
            wrapper.appendChild(currentItem);

            const titleDiv = document.createElement('div');
            titleDiv.classList.add('title');
            titleDiv.innerHTML = p.innerHTML;
            currentItem.appendChild(titleDiv);

            const contentDiv = document.createElement('div');
            contentDiv.classList.add('content');
            currentItem.appendChild(contentDiv);
          } else {
            const contentDiv = currentItem.querySelector('.content');
            contentDiv.innerHTML += (contentDiv.innerHTML.trim() ? '<br>' : '') + p.innerHTML;
          }
        }
      });

      container.innerHTML = '';
      container.appendChild(wrapper);
    });
  }

  function customerGalleryNav() {
    const navItems = document.querySelectorAll('.customer-gallery-nav__item');
    const galleryCards = document.querySelectorAll('.cutomer-gallery__card');
    const navWrap = document.querySelector('.customer-gallery-nav__wrap');
    const prevBtn = document.querySelector('.customer-gallery-nav__btn--prev');
    const nextBtn = document.querySelector('.customer-gallery-nav__btn--next');
    const buttonsContainer = document.querySelector('.customer-gallery-nav__buttons');
    const scrollIndicator = document.querySelector('.customer-gallery-nav__scroll-indicator');

    function updateScrollIndicator() {
      if (!navWrap || !scrollIndicator) return;
      const scrollableWidth = navWrap.scrollWidth - navWrap.clientWidth;
      const scrollPercentage = scrollableWidth > 0 ? navWrap.scrollLeft / scrollableWidth : 0;
      const containerWidth = navWrap.parentElement.clientWidth;
      const buttonSpace = window.innerWidth >= 750 ? 180 : 114;
      const trackWidth = containerWidth - buttonSpace;

      if (navWrap.scrollWidth > navWrap.clientWidth) {
        scrollIndicator.style.opacity = '1';
        scrollIndicator.style.width = `${Math.min(trackWidth, Math.max(0, trackWidth * scrollPercentage))}px`;
      } else {
        scrollIndicator.style.opacity = '0';
        scrollIndicator.style.width = '0px';
      }
    }

    function updateButtonStates() {
      if (!navWrap || !prevBtn || !nextBtn || !buttonsContainer) return;
      const isAtStart = navWrap.scrollLeft <= 1;
      const isAtEnd = navWrap.scrollLeft >= navWrap.scrollWidth - navWrap.clientWidth - 1;
      buttonsContainer.style.display = 'flex';
      prevBtn.disabled = isAtStart;
      nextBtn.disabled = isAtEnd;
      updateScrollIndicator();
    }

    if (navWrap && prevBtn && nextBtn) {
      prevBtn.addEventListener('click', () => navWrap.scrollBy({ left: -200, behavior: 'smooth' }));
      nextBtn.addEventListener('click', () => navWrap.scrollBy({ left: 200, behavior: 'smooth' }));
      navWrap.addEventListener('scroll', updateButtonStates);
      window.addEventListener('resize', updateButtonStates);
      setTimeout(updateButtonStates, 200);
      setTimeout(updateScrollIndicator, 250);
    }

    navItems.forEach(item => {
      item.addEventListener('click', function () {
        navItems.forEach(i => i.classList.remove('active'));
        item.classList.add('active');

        const gallerySection = document.querySelector('.cutomer-gallery');
        if (gallerySection) {
          const paddingTop = parseFloat(window.getComputedStyle(gallerySection).paddingTop) || 0;
          const rect = gallerySection.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          window.scrollTo({ top: rect.top + scrollTop + paddingTop, behavior: 'smooth' });
        }

        const filter = item.getAttribute('data-galley-category').toLowerCase();
        galleryCards.forEach(card => {
          const cat = card.getAttribute('data-categories').toLowerCase();
          card.style.display = (filter === 'all' || cat.includes(filter)) ? 'block' : 'none';
        });
      });
    });
  }

  let vatInitialised = false;
  function initVatToggle() {
    if (vatInitialised) return;
    vatInitialised = true;

    if (!window.Shopify || !window.Shopify.country) return;

    if (window.Shopify.country === 'GB') {
      const vatToggles = document.querySelectorAll('.vat-toggle input');
      const vatGlobal = localStorage.getItem('vatToggle') === 'true';

      function updateVatState(isChecked) {
        localStorage.setItem('vatToggle', isChecked ? 'true' : 'false');
        document.body.classList.toggle('vat-toggle-active', isChecked);
        vatToggles.forEach(t => { t.checked = isChecked; });
      }

      updateVatState(vatGlobal);
      vatToggles.forEach(t => {
        t.addEventListener('change', function () { updateVatState(this.checked); });
      });
    } else {
      document.body.classList.add('non-uk');
    }
  }

    if (document.querySelector('.banner__media--video')) {
    initializeVideoControls();
  }

  if (document.querySelector('#Search-In-Modal') && document.querySelector('.search-modal')) {
    searchModal();
  }

  if (document.querySelector('.swiper-container')) {
    initializeSwipers();
  }

  if (document.querySelector('.banner--overlap')) {
    sortOverlapSections();

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(sortOverlapSections, 200);
    });
  }

  if (document.querySelector('.expand-image-btn')) {
    scheduleIdle(() => lightGalleryInit());
  }

  if (document.querySelector('.popup')) {
    scheduleIdle(() => popup());
  }

  if (document.querySelector('.customer-gallery-popup__table .metafield-rich_text_field')) {
    scheduleIdle(() => formatGalleryTable());
  }

  if (document.querySelector('.customer-gallery-nav__item')) {
    scheduleIdle(() => customerGalleryNav());
  }

  if (document.querySelector('.vat-toggle input')) {
    scheduleIdle(() => initVatToggle());
  }

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;

    if (target && target.querySelector && target.querySelector('.swiper-container')) {
      initializeSwipers();
    }

    if (target && target.querySelector && target.querySelector('.banner--overlap, .banner__box')) {
      sortOverlapSections();
    }
  });

  document.addEventListener('shopify:block:select', (event) => {
    const target = event.target;

    if (target && target.closest && target.closest('.swiper-container')) {
      initializeSwipers();
    }

    if (target && target.closest && target.closest('.banner--overlap')) {
      sortOverlapSections();
    }
  });
});
/* Quantity cap for text-input product options */
(function () {
  'use strict';

  var SELECTOR = '.js-quantity-capped-input';

  function getMax(input) {
    var max = parseInt(input.dataset.maxQuantity, 10);
    return isNaN(max) || max < 1 ? null : max;
  }

  function getErrorEl(input) {
    var next = input.nextElementSibling;
    while (next) {
      if (next.classList && next.classList.contains('quantity-cap-error')) return next;
      next = next.nextElementSibling;
    }
    return null;
  }

  function validate(input, showError) {
    var max = getMax(input);
    if (max === null) return true;

    var errorEl = getErrorEl(input);
    var raw = input.value.trim();
    var message = '';

    if (raw === '') {
      // Empty is treated as valid here — cap logic has nothing to check.
      if (errorEl) errorEl.style.display = 'none';
      input.classList.remove('is-invalid');
      return true;
    }

    if (!/^\d+$/.test(raw)) {
      message = 'Please enter a number.';
    } else {
      var num = parseInt(raw, 10);
      if (num < 1) {
        message = 'Please enter a quantity of 1 or more.';
      } else if (num > max) {
        message = 'Please enter a number between 1 and ' + max + '. Sorry, being handmade this is the maximum viable number we quote for this item.';
      }
    }

    if (message) {
      if (showError && errorEl) {
        errorEl.textContent = message;
        errorEl.style.display = 'block';
      }
      input.classList.add('is-invalid');
      return false;
    }
    if (errorEl) errorEl.style.display = 'none';
    input.classList.remove('is-invalid');
    return true;
  }

  function stripNonDigits(input) {
    var cleaned = input.value.replace(/\D/g, '');
    if (cleaned !== input.value) {
      var diff = input.value.length - cleaned.length;
      var pos = Math.max(0, (input.selectionStart || 0) - diff);
      input.value = cleaned;
      try { input.setSelectionRange(pos, pos); } catch (e) {}
    }
  }

  function init() {
    var inputs = document.querySelectorAll(SELECTOR);
    if (!inputs.length) return;

    inputs.forEach(function (input) {
      input.addEventListener('input', function () {
        stripNonDigits(input);
        validate(input, false); // silent while typing
      });
      input.addEventListener('blur', function () {
        validate(input, true);
      });
    });

    var forms = new Set();
    inputs.forEach(function (input) {
      var form = input.closest('form');
      if (form) forms.add(form);
    });

    forms.forEach(function (form) {
      // Capture phase so we run before any other submit handlers.
      form.addEventListener('submit', function (e) {
        var capped = form.querySelectorAll(SELECTOR);
        var firstInvalid = null;
        capped.forEach(function (input) {
          if (!validate(input, true) && !firstInvalid) firstInvalid = input;
        });
        if (firstInvalid) {
          e.preventDefault();
          e.stopPropagation();
          firstInvalid.focus();
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();